import { render, staticRenderFns } from "./ImgViewBtns.vue?vue&type=template&id=5bd2a34a&scoped=true&"
import script from "./ImgViewBtns.vue?vue&type=script&lang=js&"
export * from "./ImgViewBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2a34a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd2a34a')) {
      api.createRecord('5bd2a34a', component.options)
    } else {
      api.reload('5bd2a34a', component.options)
    }
    module.hot.accept("./ImgViewBtns.vue?vue&type=template&id=5bd2a34a&scoped=true&", function () {
      api.rerender('5bd2a34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/view-report/components/ImgViewBtns.vue"
export default component.exports